// TRIAL50 은 체험 종료 후 14일까지 유효하므로, 체험 막바지에만 띄워도 할인 기간은 줄지 않는다.
export const TRIAL_BUBBLE_MAX_REMAINING_DAYS = 3;
export const RENEWAL_BUBBLE_MAX_REMAINING_DAYS = 7;

export const isDiscountBubbleTime = ({ isTrialOffer, remainingDays }) => {
  if (remainingDays === null || remainingDays === undefined) return false;
  const maxRemainingDays = isTrialOffer
    ? TRIAL_BUBBLE_MAX_REMAINING_DAYS
    : RENEWAL_BUBBLE_MAX_REMAINING_DAYS;
  return remainingDays <= maxRemainingDays;
};
